module.exports = __webpack_public_path__ + "img/cnu_gallery9.b790f914.jpg";